import styles from './styles.module.scss';

type Props = {
  messages: string[];
};

export const ErrorMessages: React.FC<Props> = ({ messages }) => {
  if (messages.length === 0) return null;

  return (
    <ul className={styles.ErrorMessages}>
      {messages.map((message, index) => (
        <li className={styles.ErrorMessages__MessageItem} key={`${message}-${index}`}>
          <span className={styles.ErrorMessages__MessageItem__Message}>{message}</span>
        </li>
      ))}
    </ul>
  );
};
